export const Roles = Object.freeze({
	Undefined: { value: -1, label: "-" },
	SpaghettiMonster: { value: 1, label: "Spaghetti Monster" },
	Housekeeper: { value: 2, label: "Housekeeper" },
	ContentCreator: { value: 3, label: "Content Creator" },
	CustomerAdmin: { value: 4, label: "Customer Admin" },
	Demonstrator: { value: 5, label: "Demonstrator" },
	Learner: { value: 6, label: "Learner" },
});

export const CompanyUserRole = Object.freeze(
	Object.fromEntries(Object.entries(Roles).map(([k, v]) => [k, v.value]))
);

export const CompanyUserRoleNames = Object.freeze(
	Object.fromEntries(Object.values(Roles).map(r => [r.value, r.label]))
);

export const roleLabel = (id) => CompanyUserRoleNames[id] ?? String(id);

export const AssignableRoleOptionsBase = Object.freeze(
	[Roles.CustomerAdmin, Roles.Learner].map(r => ({ label: r.label, value: r.value }))
);

export const getAssignableRoleOptions = (currentId) =>
	currentId === CompanyUserRole.Undefined
		? [{ label: Roles.Undefined.label, value: Roles.Undefined.value }, ...AssignableRoleOptionsBase]
		: AssignableRoleOptionsBase;

export const showRoleDropdown = (id) =>
	[CompanyUserRole.Undefined, CompanyUserRole.CustomerAdmin, CompanyUserRole.Learner].includes(id);
